import { Component, Input } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';

@Component({ standalone: false,
  selector: '[mx-table-empty-message]',
  templateUrl: './mx.table-empty-message.component.html',
  styleUrls: ['./mx.table-empty-message.component.scss'],
})
export class MxTableEmptyMessageComponent extends MxBaseComponent {
  @Input() columns: MxTableColumn[];
}
